export const setContent = (state, payload) => {
    state.contentData = payload;
};

export const setPaymentContent = (state, payload) => {
    state.paymentData = payload;
};